import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Home from './Home';
import Phantom from './Phantom';
import Soul from './Soul';
import Products from './Products';
import Media from './Media';
import './styles/app.scss'
import Footer from './components/Footer';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-178046012-4');

const App = () => (
    <div className="App">
      <Router basename={process.env.PUBLIC_URL}>
      <Nav />
        <Switch>
          <Route path="/" exact component={Home}/>
          <Route path="/phantom-brave" exact component={Phantom}/>
          <Route path="/soul-nomad" exact component={Soul}/>
          <Route path="/products" exact component={Products}/>
          <Route path="/media" exact component={Media}/>
        </Switch>
      <Footer/>
      </Router>
    </div>
)

export default App;
